import { Component, Input, OnInit } from '@angular/core';
import { ModalService } from 'src/app/services/modal.service';
import { GenericModalType } from 'src/app/types/modals';

@Component({
  selector: 'app-generic-info-popup',
  templateUrl: './generic-info-popup.component.html',
  styleUrls: ['./generic-info-popup.component.scss'],
})
export class GenericInfoPopupComponent implements OnInit {
  @Input() header: string = '';
  @Input() message: string = '';
  @Input() type: GenericModalType = GenericModalType.INFO;

  public readonly iconColorMap: Record<GenericModalType, string> = {
    [GenericModalType.INFO]: 'color-primary-2',
    [GenericModalType.WARNING]: 'color-state-warning',
    [GenericModalType.ERROR]: 'color-state-error',
    [GenericModalType.SUCCESS]: 'color-state-success',
  };

  constructor(
    public readonly modalService: ModalService,
  ) {}

  ngOnInit() {
    return;
  }
}
